import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dataSourceHandleActions } from "_actions";
import { getPlatform, PLATFORM } from "../../../Messages/MessageDetails/Utilities/MessageDetailsUtils";

export default function useDataSourceHandles(organizationId) {
    const dispatch = useDispatch();
    const platform = getPlatform(organizationId);

    const getAllDataSourceHandles = useCallback(() => {
        if (!organizationId) return;

        const payload = (platform === PLATFORM.TEAMS || platform === PLATFORM.VOTE)
            ? { organization: organizationId }
            : platform === PLATFORM.TRENDS
                ? { trendsOrganization: organizationId }
                : null;

        if (payload) {
            dispatch(dataSourceHandleActions.getAll(payload));
        }
    }, [dispatch, organizationId, platform]);

    useEffect(() => {
        getAllDataSourceHandles();
    }, [getAllDataSourceHandles]);

    const dataSourceHandles = useSelector(state => state.dataSourceHandles.dataSourceHandles);
    const loadingDataSourceHandles = useSelector(state => state.dataSourceHandles.loading);

    return { dataSourceHandles, loadingDataSourceHandles };
}